import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { NotificationRead } from '../models/NotificationRead';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationReadService {
    API_URL = `${environment.apiUrl}/notification-read`;

  constructor(private http: HttpClient) { }

  saveNotificationRead(notificationRead: NotificationRead){
    return this.http.post(`${this.API_URL}`,notificationRead);
  }

  markAllAsRead(email: string): Observable<void> {
    return this.http.put<void>(`${this.API_URL}/mark-all-read?email=${email}`, null);
  }

  markAsRead(notificationId: string, email: string): Observable<void> {
    return this.http.put<void>(`${this.API_URL}/${notificationId}/read?email=${encodeURIComponent(email)}`, null);
  }

  isNotificationReadable(notificationId: string, email: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.API_URL}/${notificationId}/is-readable?email=${email}`);
  }
}
